import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, ModalFooter, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ModalBody from 'react-bootstrap/ModalBody';
import AddEditBeneficiaryModal from '../../../components/AddNewBeneficiary/AddEditBeneficiaryModal';
import Button from '../../../components/Button';
import FamilyMemberModalCard from '../../../components/FamilyMemberCard/FamilyMemberModalCard';
import ModalHeader from '../../../components/ModalHeader';
import useMobile from '../../../hooks/useMobileHook';
import useModal from '../../../hooks/useModal';

export type customModalProps = {
  showModal: boolean;
  handleCloseModal: () => void;
  addFamilyMember: (data: any) => void;
  familyMembers: any;
};

const ViewFamilyMembersModal = ({
  showModal,
  handleCloseModal,
  addFamilyMember,
  familyMembers,
}: customModalProps) => {
  const [
    showAddFamilyMemberModal,
    handleAddFamilyMemberShow,
    handleAddFamilyMemberClose,
  ] = useModal();

  const isMobile = useMobile();

  const handleAddFamilyMemberSubmit = (data: any) => {
    const convertedSSN = data.ssn.split('-').join('');
    addFamilyMember({ ...data, ssn: +convertedSSN });

    const profile = {
      ...data,
      ssn: +convertedSSN,
      id: (familyMembers.length + 1).toString(),
      isVerified: false,
      dateOfBirth: new Date(data.dob).getTime(),
      name: `${data.firstName} ${data.lastName}`,
      covers: [],
      address: {
        address1: data.address1,
        address2: data.address2,
        city: data.city,
        state: data.state,
        zipcode: data.zipcode,
      },
    };
    familyMembers.push(profile);
  };

  return (
    <Modal
      show={showModal}
      fullscreen={isMobile}
      onHide={handleCloseModal}
      dialogClassName="modal-xl"
      className="custom-view-family-members-modal"
    >
      <ModalHeader closeButton>
        <h4 className="text-truncate">Add/View Family Members</h4>
      </ModalHeader>
      <ModalBody>
        <Container className="p-0">
          <Row className="pb-lg-10">
            <Container
              className={'d-flex justify-content-between align-items-center'}
            >
              <h6 className={'mb-0 text-sm-16-lg-20'}>
                List of Family Members
              </h6>

              <Button
                size={'sm'}
                rightIcon={light('circle-plus')}
                onMouseDown={handleAddFamilyMemberShow}
              >
                Add New
              </Button>
            </Container>
          </Row>
          <Row className={'d-none d-lg-flex'}>
            <Col className={'col-lg-4 offset-4'}>
              <span className={'fw-normal text-fs-6 text-light-grey'}>SSN</span>
            </Col>
            <Col className={'col-lg-4 d-flex justify-content-end'}>
              <span className={'fw-normal text-fs-6 text-light-grey'}>
                Benefits
              </span>
            </Col>
          </Row>
          <Row>
            <Col className={'mt-7 d-flex flex-column gap-7'}>
              {familyMembers.map((familyMember: any, index: number) => (
                <FamilyMemberModalCard
                  key={index}
                  name={familyMember.name}
                  covers={familyMember.covers}
                  image={familyMember.image}
                  ssn={familyMember.ssn}
                  relationship={familyMember.relationship}
                  dateOfBirth={familyMember.dateOfBirth}
                />
              ))}
            </Col>
          </Row>
        </Container>
        <AddEditBeneficiaryModal
          title="Manage Family Members"
          subtitle='Add New Family members'
          isForFamilyMember={true}
          showModal={showAddFamilyMemberModal}
          handleClose={handleAddFamilyMemberClose}
          handleSubmit={handleAddFamilyMemberSubmit}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseModal}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ViewFamilyMembersModal;
